export const GET_GIT_REPOS_REQUEST = "GET_GIT_REPOS_REQUEST";
export const GET_GIT_REPOS_SUCCESS = "GET_GIT_REPOS_SUCCESS";
export const GET_GIT_REPOS_FAILURE = "GET_GIT_REPOS_FAILURE";

export const GET_ALL_GIT_REPOS_REQUEST = "GET_ALL_GIT_REPOS_REQUEST";
export const GET_ALL_GIT_REPOS_SUCCESS = "GET_ALL_GIT_REPOS_SUCCESS";
export const GET_ALL_GIT_REPOS_FAILURE = "GET_ALL_GIT_REPOS_FAILURE";
